import React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridPaginationModel, GridRowParams } from "@mui/x-data-grid";
import "./datagrid.css";
import CustomFooterComponent from "./Footer";
import SortIcon from "./SortIcon";

interface FaiDataGridProps {
	rows: any[];
	columns: any[];
	columnProps?: any;
	onRowClick?: (params: GridRowParams) => void;
	pagination?: boolean;
	pageSize?: number;
	rowCount?: number;
	paginationMode?: "client" | "server";
	paginationModel?: GridPaginationModel;
	customStyles?: React.CSSProperties;
	onPaginationModelChange?: (model: GridPaginationModel) => void;
}

const FaiDataGrid: React.FC<FaiDataGridProps> = ({
	rows = [],
	columns = [],
	columnProps = { flex: 1, minWidth: 150 },
	onRowClick,
	pagination = true,
	pageSize = 10,
	rowCount,
	paginationMode = "client",
	onPaginationModelChange,
	customStyles = {},
	...dataGridProps
}) => {
	return (
		<Box sx={{ maxHeight: "70vh", width: "100%", overflow: "auto" }}>
			<DataGrid
				rows={rows}
				columns={columns.map((column) => ({
					...(column.field === "isChecked" ? {} : columnProps),
					...column,
				}))}
				autoHeight
				initialState={{
					pagination: pagination && {
						paginationModel: {
							pageSize: pageSize,
						},
					},
				}}
				slots={{
					footer: pagination ? CustomFooterComponent : () => <></>,
					columnHeaderSortIcon: (props) => <SortIcon {...props} />,
				}}
				className="fai-dg"
				classes={{
					columnHeaders: "fai-datagrid-column-headers",
				}}
				style={{
					...customStyles,
				}}
				onRowClick={onRowClick}
				rowCount={rowCount}
				paginationMode={paginationMode}
				onPaginationModelChange={onPaginationModelChange}
				{...dataGridProps}
			/>
		</Box>
	);
};

export default FaiDataGrid;
